import React from 'react';

interface ILinkProps {
  children: React.ReactNode;
}

export const Link = ({ children, ...restProps }: ILinkProps) => (
  <a target="_blank" rel="noopener noreferrer" {...restProps} data-test="link">
    {children}
  </a>
);
